import {imageProcess} from '../../plugins/image-process';

export default {
  state: {
    drawing: null,
    completedDrawing: null,
  },
  getters: {
    DRAWING: state => {
      return state.drawing;
    },
    COMPLETED_DRAWING: state => {
      return state.completedDrawing;
    },
  },
  mutations: {
    SET_DRAWING: (state, payload) => {
      state.drawing = payload;
    },
    SET_COMPLETED_DRAWING: (state, payload) => {
      state.completedDrawing = payload;
    },
  },
  actions: {
    SET_DRAWING: (context, drawing) => {
      if (drawing && drawing.photo) {
        const cropper = document.getElementById(`img-${drawing.photo.productId ? drawing.photo.productId : drawing.photo.id}`);

        if (cropper) {
          let minWidth = 0, minHeight = 0;
          const img = cropper.querySelector('.cropper-hidden');

          if (img) {
            minWidth = imageProcess.getImgMinSize(img).minWidth;
            minHeight = imageProcess.getImgMinSize(img).minHeight;
          }

          drawing.photo.minWidth = minWidth;
          drawing.photo.minHeight = minHeight;
        }
      }

      context.commit('SET_DRAWING', drawing);
    },
    SET_COMPLETED_DRAWING: (context, completedDrawing) => {
      context.commit('SET_COMPLETED_DRAWING', completedDrawing);
    },
  },
};